import { ProformaFront, Page, DatatableMessage } from '../../models/api.models';

export class ProformaData {
    proformasFront: ProformaFront[];
    page: Page;
    msg: DatatableMessage;
}
